let _observer = null;

export const setCollapseSimplifyViewObserver = (observerIns) => {
  _observer = observerIns;
}

export const getCollapseSimplifyViewObserver = () => {
  return _observer;
}
